/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ action: NonNullable<unknown> }} Agent_Builder_Result_Action_UnavailableInputs */



/**
* | output |
* | --- |
* | "{action} (connect the app to use it)" |
*
* @param {Agent_Builder_Result_Action_UnavailableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_result_action_unavailable = /** @type {((inputs: Agent_Builder_Result_Action_UnavailableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Result_Action_UnavailableInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.action} (erst nach Verbinden der App verfügbar)`)
	return /** @type {LocalizedString} */ (`${i?.action} (connect the app to use it)`)
});